<script setup lang="ts">
import { ref,computed } from 'vue'
import DxButton from 'devextreme-vue/button';
import { useCalcBuildingStore } from "../store/useCalcBuildingStore";
const $buildingStore = useCalcBuildingStore();
const props =defineProps<{ 
item:any,
 type:string
}>()
const buttonRef = ref(null);
const visibleButton = computed(()=>{
  const butItem = props.item;
  const currentValButton = butItem.value;

  var avaibleButtons = $buildingStore.currentButtons
  const checkDim = avaibleButtons.find(x=>x.dim==props.type)
  if(checkDim && checkDim.vals && checkDim.vals.length){
    const checkVal = checkDim.vals.find((x: any)=>x == currentValButton);
    if(checkVal){
      return "param-button visible-animation button-bordered"
    }
  }


  return "param-button"


})
const customStyle = computed( ()=> {
  const staticStyle= "";
  const currentVal = $buildingStore.currentCardParams[props.type];
  const selectionStyle = props.item.value == currentVal?'background-color: #722082; color: #ffffff':''
  return staticStyle  + selectionStyle
})
const setDimValue = ()=>{
  //ym(87107319,'reachGoal','changeSize')
  $buildingStore.changeCardParams(props.type, props.item.value);
  ym(87107319,'reachGoal','changeSize');
}
</script>

<template>
  

  
  <DxButton :class="visibleButton" :style="customStyle" ref="buttonRef"
    :text="item.text" :focusStateEnabled="false" @click="setDimValue" :visible="visibleButton != 'param-button'" />

</template>

<style scoped>
.button-bordered {
  border: 0.09rem solid #999;      /* серая граница */
  border-radius: 0.25rem;         /* скругление углов */
  background-color: white;     /* белый фон */
  padding: 0.5rem 1rem;        /* внутренние отступы */
        /* размер цифры */           /* жирный текст */
              /* цвет текста */
  text-align: center;
  cursor: pointer;
}
.visible-animation {
  
  /* animation: glow 1s 0.5s alternate; */

}
@keyframes glow {
  from {
    box-shadow: 0 0 10px -10px 	rgb(114,32,130);
  }
  to {
    box-shadow: 0 0 10px 10px rgb(114,32,130);
  }
}
</style>
